export default {
  Assignment: {
    AfterFinishExercise: 'Ngay khi hoàn thành bài',
    AfterExpired: 'Sau khi hết hạn nộp',
    SubmittedExerciseTime: 'Hạn nộp bài',
    NoDeadline: 'Không yêu cầu nộp',
    SetScheduleDate: 'Lịch giao bài',
    ChoseClasses: 'Lớp nhận bài',
    SubmitAnswer: 'Học sinh nhận đáp án',
    AllowCompensate: 'Cho phép học sinh chỉnh sửa lại bài sau khi nộp',
    MessageToStudent: 'Lời nhắn tới học sinh',
    EnterTextMessage: 'Nhập văn bản',
    InvalidMaxCharacterTeacherMessage: 'Lời nhắn tới học sinh không được vượt quá 300 ký tự',
    Exercise: 'Bài tập',
    Documentation: 'Tài liệu tham khảo',
    TurnOn: 'Bật',
    TurnOff: 'Tắt',
    Day: 'Ngày',
    Assign: 'Giao bài',
    Cancel: 'Hủy',
    NoDateUpload: 'Không yêu cầu nộp',
    AddExercise: 'Thêm bài tập',
    AddDocument: 'Thêm tài liệu',
    FullDocument: 'Số tài liệu tham khảo quá số lượng được chọn ! ',
    Question: 'Câu',
    Warning: 'Cảnh báo',
    NotChooseClassWarning: 'Bạn vui lòng chọn lớp nhận bài.',
    NotChooseExerciseWarning: 'Bạn vui lòng chọn bài tập để gửi cho lớp.',
    NotChooseClassAndExercise: 'Bạn vui lòng chọn lớp nhận bài, chọn bài tập để gửi cho lớp.',
    InvalidDeadline: 'Hạn nộp bài phải lớn hơn thời gian hiện tại.',
    InvalidScheduleDate: 'Thời gian giao bài phải lớn hơn thời gian hiện tại',
    InvalidDealineAndSchedule: 'Hạn nộp bài phải lớn hơn thời gian giao bài.',
    EmptyStudent: 'Lớp <b>{ClassName}</b> bạn chọn giao bài hiện không có học sinh nào.',
    Understand: 'Đồng ý',
    Done: 'Hoàn thành',
    Search: 'Tìm kiếm',
    Close: 'Đóng',
    Accept: 'Đồng ý',
    InvalidDealineEdit: 'Bạn chỉ được phép tăng hạn nộp bài.',
    TitlePopup: 'Chọn bài tập từ Học liệu của bạn',
    ExerciseNotFound: 'Không tìm thấy bài tập',
    MainClass: 'Lớp chính quy',
    ShareContent: 'Gửi lời mời tham gia lớp học',
    SelectComposedExercise: 'Chọn bài đã soạn',
    TotalSelectedExercise: '(Đã chọn: {Count})',
    TotalQuestion: '{Total} Câu',
    NotSelectExerciseToView: 'Chưa chọn bài để xem',
    Filter: 'Bộ lọc',
    ChooseFromComputer: 'Chọn từ máy tính',
    ChooseFromGoogleDrive: 'Chọn từ Google Drive',
    ComposeSuccess: 'Soạn bài thành công',
    ComposeSuccessHint: 'Thầy/cô vừa hoàn thành soạn và lưu bài tập vào kho học liệu cá nhân <br/> Thầy/cô có muốn chia sẻ đến các thầy/cô trong cộng đồng?',
    ShareTo: 'Chia sẻ lên',
    TeacherCommunity: 'Cộng đồng giáo viên'
  }
}
